module.exports = __webpack_public_path__ + "img/scene30.eba8eaa3.gif";